import React, { useState, useRef } from 'react';
import { Card, Button, Space, Typography, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import RideAPI from 'services/ride';

const { Text } = Typography;

const RideImageContainer = ({ rideDetails, rideId, updateRideImage, getRideDetails }) => {
    const [uploading, setUploading] = useState(false);
    const [isUploadHovered, setIsUploadHovered] = useState(false);
    const fileInputRef = useRef(null);



    const handleUpload = async (file) => {
        if (!file) return;

        setUploading(true);
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await RideAPI.uploadRideImage(rideId, formData);

            if (response && response.statusCode === 200) {
                message.success('Image uploaded successfully!');

                const newImageURL = response.data.imageURL;

                if (updateRideImage) {
                    updateRideImage(rideId, newImageURL);
                }
                if (getRideDetails) {
                    getRideDetails(rideId);
                }
            } else {
                message.error('Failed to upload image');
            }
        } catch (error) {
            console.error('Upload error:', error);
            const errorMessage =
                error?.response?.data?.data?.message ||
                error?.response?.data?.message ||
                'Error uploading image';
            message.error(errorMessage);
        } finally {
            setUploading(false);
        }
    };

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
            if (!allowedTypes.includes(file.type)) {
                message.error('Please select a valid image file (JPEG, PNG, or WEBP)');
                return;
            }

            const maxSize = 10 * 1024 * 1024; // 10MB
            if (file.size > maxSize) {
                message.error('File size should be less than 10MB');
                return;
            }

            handleUpload(file);
        }
        event.target.value = '';
    };

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Card
            style={{
                marginBottom: 24,
                borderRadius: '8px',
                width: '80%',
                backgroundColor: '#fff',
                border: '1px solid #eaeaea',
            }}
            bodyStyle={{ padding: 24 }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', padding: '8px 0' }}>

                {/* Left Section - Buttons */}
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '16px' }}>
                    <Text
                        style={{
                            color: '#606060',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            marginBottom: '12px',
                            display: 'block',
                            letterSpacing: '2px'
                        }}
                    >
                        RIDE IMAGE
                    </Text>

                    <Space direction="vertical" size={12}>
                        <Button
                            type="primary"
                            icon={<UploadOutlined />}
                            loading={uploading}
                            onClick={triggerFileInput}
                            onMouseEnter={() => setIsUploadHovered(true)}
                            onMouseLeave={() => setIsUploadHovered(false)}
                            style={{
                                backgroundColor: '#6528D8',
                                borderColor: '#6528D8',
                                borderRadius: '6px',
                                width: '100%',
                                transform: isUploadHovered ? 'scale(1.06)' : 'scale(1)',
                                transformOrigin: 'center',
                                boxShadow: isUploadHovered
                                    ? '0 0 10px rgba(101, 40, 216, 0.45), 0 0 22px rgba(101, 40, 216, 0.3)'
                                    : '0 0 0 rgba(0, 0, 0, 0)',
                                transition: 'transform 0.2s ease, box-shadow 0.25s ease',
                            }}
                        >
                            {uploading ? 'Uploading...' : 'Upload NEW Image'}
                        </Button>
                    </Space>

                    {/* Hidden file input */}
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileSelect}
                        accept="image/*"
                        style={{ display: 'none' }}
                    />
                </div>

                {/* Right Section - Image Display */}
                <div style={{ display: 'flex', padding: '4px', backgroundColor: '#eee', borderRadius: '8px', maxHeight: '300px', maxWidth: '300px' }}>
                    {rideDetails && rideDetails.imageURL ? (
                        <div style={{ textAlign: 'center' }}>
                            <img
                                src={rideDetails.imageURL}
                                alt="Ride Image"
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '300px',
                                    borderRadius: '8px',
                                    border: '1px solid #eaeaea',
                                    objectFit: 'contain',
                                }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                            <div style={{
                                display: 'none',
                                padding: '40px',
                                textAlign: 'center',
                                color: '#999',
                                border: '1px dashed #d9d9d9',
                                borderRadius: '8px'
                            }}>
                                Failed to load image
                            </div>
                        </div>
                    ) : (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '200px',
                                border: '2px dashed #d9d9d9',
                                borderRadius: '8px',
                                backgroundColor: '#fafafa',
                                color: '#999',
                                fontSize: '16px',
                            }}
                        >
                            No image uploaded
                        </div>
                    )}
                </div>
            </div>
        </Card >
    );
};

export default RideImageContainer;

